interface BandMembersModalProps {
  bandName: string;
  onClose: () => void;
  onShowMemberProfile: (
    name: string,
    instrument: string,
    experience: string
  ) => void;
}

const BandMembersModal = ({
  bandName,
  onClose,
  onShowMemberProfile,
}: BandMembersModalProps) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="gradient-bg text-white p-6 rounded-t-xl">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold">{bandName} - メンバー</h2>
            <button
              onClick={onClose}
              className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-full transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full flex items-center justify-center text-white font-bold mr-3">
                  YT
                </div>
                <div>
                  <h4 className="font-semibold">山田太郎</h4>
                  <p className="text-sm text-gray-600">ドラム • リーダー</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                  リーダー
                </span>
                <button
                  onClick={() =>
                    onShowMemberProfile("山田太郎", "ドラム", "10年")
                  }
                  className="text-blue-500 text-sm hover:underline"
                >
                  プロフィール
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-gradient-to-r from-green-400 to-blue-400 rounded-full flex items-center justify-center text-white font-bold mr-3">
                  ST
                </div>
                <div>
                  <h4 className="font-semibold">佐藤花子</h4>
                  <p className="text-sm text-gray-600">ボーカル</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                  メンバー
                </span>
                <button
                  onClick={() =>
                    onShowMemberProfile("佐藤花子", "ボーカル", "7年")
                  }
                  className="text-blue-500 text-sm hover:underline"
                >
                  プロフィール
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-gradient-to-r from-red-400 to-pink-400 rounded-full flex items-center justify-center text-white font-bold mr-3">
                  TK
                </div>
                <div>
                  <h4 className="font-semibold">田中一郎</h4>
                  <p className="text-sm text-gray-600">ギター</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                  メンバー
                </span>
                <button
                  onClick={() =>
                    onShowMemberProfile("田中一郎", "ギター", "12年")
                  }
                  className="text-blue-500 text-sm hover:underline"
                >
                  プロフィール
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full flex items-center justify-center text-white font-bold mr-3">
                  WM
                </div>
                <div>
                  <h4 className="font-semibold">渡辺美咲</h4>
                  <p className="text-sm text-gray-600">ベース</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                  メンバー
                </span>
                <button
                  onClick={() =>
                    onShowMemberProfile("渡辺美咲", "ベース", "5年")
                  }
                  className="text-blue-500 text-sm hover:underline"
                >
                  プロフィール
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between p-4 border border-dashed border-gray-300 rounded-lg bg-gray-50">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center text-gray-500 font-bold mr-3">
                  ?
                </div>
                <div>
                  <h4 className="font-semibold text-gray-500">募集中</h4>
                  <p className="text-sm text-gray-500">キーボード</p>
                </div>
              </div>
              <button className="bg-blue-500 text-white px-3 py-1 rounded text-sm hover:bg-blue-600 transition-colors">
                募集詳細
              </button>
            </div>
          </div>

          <button
            onClick={onClose}
            className="w-full mt-6 py-3 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
};

export default BandMembersModal;
